"use client"
import { cn } from "@/lib/utils"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"

import { ForwardIcon } from "@/icons"
import { usePathname } from "next/navigation"
import { useTranslate } from "@tolgee/react"
interface BreadcrumbsProps {
  items: { label: string; path: string }[]
  className?: string
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  const pathname = usePathname()
  const { t } = useTranslate()
  return (
    <nav className={cn("flex", className)}>
      <ol className="inline-flex items-center gap-2">
        {items.map(({ path, label }, index) => {
          const isActive = pathname === path
          return (
            <li key={label} className="inline-flex items-center">
              {index > 0 && <ForwardIcon size={16} />}
              <LocalizedClientLink
                href={path}
                className={cn(
                  "inline-flex items-center label-md text-primary",
                  index > 0 && "ml-2",
                  isActive && "text-secondary"
                )}
              >
                {/* {label} */}
              </LocalizedClientLink>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
